module.exports = __webpack_public_path__ + "img/commentRate_5.d5179da4.png";